/**
 * Vuex "messages" module (registered as `messages` in the root store).
 *
 * Aggregates direct-message/group-chat state: conversation list, per-conversation
 * message history, typing/presence, drafts, and DM settings, plus the actions
 * (actions.js), getters (getters.js), and mutations (mutations.js) that drive it.
 */
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export default {
  namespaced: false,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
